// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"b4339dd985fac57e","5285":"d28db42242fe5995"}[chunkId] + ".css";
};